import { render, staticRenderFns } from "./LoadMore.vue?vue&type=template&id=54a1705c&scoped=true"
import script from "./LoadMore.vue?vue&type=script&lang=js"
export * from "./LoadMore.vue?vue&type=script&lang=js"
import style0 from "./LoadMore.vue?vue&type=style&index=0&id=54a1705c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a1705c",
  null
  
)

export default component.exports